module.exports = __webpack_public_path__ + "media/customizations/regencyattentrails/back-9633afac3fe48b599db9d1e91aa9ad5c.jpg";